import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class MobileStaticPanel extends Component {
    constructor() {
        super(...arguments);
        this.mask = React.createRef();
        this.state = {
            isShown: false,
        };
        this.handleTapOrClickMask = (e) => {
            const mask = this.mask.current;
            if (e.target === mask && e.type !== 'touchcancel') {
                const { clickMaskDestoryPanel = true } = this.props;
                this.hide(clickMaskDestoryPanel);
                e.stopPropagation();
                e.preventDefault();
            }
        };
        this.show = () => {
            var _a, _b;
            const mask = this.mask.current;
            mask.addEventListener('contextmenu', e => e.preventDefault());
            mask.addEventListener('click', this.handleTapOrClickMask);
            this.setState({ isShown: true });
            (_b = (_a = this.props).onShow) === null || _b === void 0 ? void 0 : _b.call(_a, this);
        };
        this.hide = (destory = true) => {
            this.hidePanel(destory);
        };
        this.hidePanel = (destory = true) => {
            var _a, _b;
            (_b = (_a = this.props).onHide) === null || _b === void 0 ? void 0 : _b.call(_a, this);
            this.setState({ isShown: false });
            return new Promise((resolve) => {
                setTimeout(() => {
                    var _a;
                    if (((_a = this.mask.current) === null || _a === void 0 ? void 0 : _a.parentElement) && destory) {
                        ReactDOM.unmountComponentAtNode(this.mask.current.parentElement);
                    }
                    resolve();
                }, 300);
            });
        };
    }
    componentDidMount() {
        this.show();
    }
    render() {
        const { className = '', style = {}, isBackgroundBlur, preferredHeight, } = this.props;
        const wrapperStyle = Object.assign(Object.assign({}, style), { transform: `translateY(-${preferredHeight}px)` });
        return React.createElement("div", { className: `mobile-pull-panel-v2-mask mobile-pull-panel-v2-static ${this.state.isShown ? '' : 'mobile-pull-panel-v2-hidden'}`, ref: this.mask },
            React.createElement("div", { className: `mobile-pull-panel-v2 ${isBackgroundBlur ? 'mobile-pull-panel-v2-blur ' : ''}${className || ''}`, style: wrapperStyle },
                React.createElement("div", { className: "mobile-pull-panel-v2-children-wrapper" }, this.props.children)));
    }
}

export { MobileStaticPanel };
//# sourceMappingURL=panel.js.map
